"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _socialIconFactory = _interopRequireDefault(require("./socialIconFactory"));
var useClasses = (0, _styles.makeStyles)({
  root: {
    '&:hover, &:focus': {
      color: '#6441A4'
    }
  },
  focus: {
    color: '#6441A4'
  }
}, {
  classNamePrefix: 'TCUIIconTwitch'
});
var Twitch = (0, _socialIconFactory.default)(useClasses, ['fab', 'twitch'], 'Twitch');
var _default = Twitch;
exports.default = _default;